import enUs from 'date-fns/locale/en-US';
import * as React from 'react';
import * as ReactDatePickerNS from 'react-datepicker';
import type ReactDatePickerType from 'react-datepicker';

import { datePickerFormat } from '@acceligentllc/shared/utils/time';

import { TimeFormat } from '@acceligentllc/shared/enums/timeFormat';

import { RectangleButton } from 'af-components/MultipleOptionsButton/RectangleButton';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const DatePicker = ((ReactDatePickerNS as any).default?.default ?? (ReactDatePickerNS as any).default ?? ReactDatePickerNS) as typeof ReactDatePickerType;

interface OwnProps {
	selected: Date;
	onChange: (date: Date) => void;
}

type Props = OwnProps;

class DailyPicker extends React.PureComponent<Props> {

	private _datepicker: Nullable<ReactDatePickerType> = null;

	onSelect = (date: Nullable<Date>) => {
		const { onChange } = this.props;
		onChange(date ?? new Date());
	};

	setDatepickerRef = (datepicker: ReactDatePickerType) => { this._datepicker = datepicker; };

	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	focusDatePicker = () => (this._datepicker as any).input.focus();

	render() {
		const { selected } = this.props;

		return (
			<div className="table-filter__date">
				<DatePicker
					className="form-control"
					dateFormat={datePickerFormat(TimeFormat.DATE_ONLY)}
					disabledKeyboardNavigation
					dropdownMode="select"
					locale={enUs}
					onChange={this.onSelect}
					ref={this.setDatepickerRef}
					selected={selected}
					showMonthDropdown={true}
					showYearDropdown={true}
					todayButton="Today"
				/>
				<RectangleButton
					action={this.focusDatePicker}
					isLeftOpen={true}
					isSquare={true}
					label={<span className="icon-calendar" />}
				/>
			</div>
		);
	}
}

export default DailyPicker;
